import React from 'react'
import { Child, Guardian } from '../../../providers/context'
import { Button, ButtonShape, ButtonStyle } from '../../../components/simple/button'

export const RegardingStudentSelector: React.FC<{
  user: Guardian
  regardingStudent: Child | undefined
  setRegardingStudent: React.Dispatch<React.SetStateAction<Child | undefined>>
}> = ({ user, regardingStudent, setRegardingStudent }) => {
  const children = React.useMemo(() => user.children || [], [user])

  React.useEffect(() => {
    if (regardingStudent === undefined && children.length > 0) setRegardingStudent(children[0])
  }, [children, regardingStudent])

  if (children.length < 2) return null
  return (
    <div className="flex flex-wrap gap-2">
      {children.map((child, i) => (
        <Button
          shape={ButtonShape.rounded}
          buttonStyle={child === regardingStudent ? ButtonStyle.blueLight : ButtonStyle.light}
          onClick={() => setRegardingStudent(child)}
          key={child.id}
        >
          {child.name}
        </Button>
      ))}
    </div>
  )
}
